import { gql, TypedDocumentNode } from "@apollo/client";
import { PersonProfileDocument } from "./queries";

export type PersonProfileDocumentMutationResponse = {
  success: boolean;
  message?: string | null;
  personProfileDocument?: PersonProfileDocument | null;
};

export const CREATE_PERSON_PROFILE_DOCUMENT_MUTATION: TypedDocumentNode<
  { createPersonProfileDocument: PersonProfileDocumentMutationResponse },
  {
    input: {
      personId: string;
      name: string;
      description?: string | null;
      category: string;
      document: File;
      privacyRestricted?: boolean;
    };
  }
> = gql`
  mutation CreatePersonProfileDocument($input: BackofficeCreatePersonProfileDocumentInput!) {
    createPersonProfileDocument(input: $input) {
      success
      message
      personProfileDocument {
        id
        name
        description
        category
        filename
        url
        privacyRestricted
        createdAt
      }
    }
  }
`;

export const UPDATE_PERSON_PROFILE_DOCUMENT_MUTATION: TypedDocumentNode<
  { updatePersonProfileDocument: PersonProfileDocumentMutationResponse },
  {
    input: {
      id: string;
      name?: string;
      description?: string | null;
      category?: string;
      privacyRestricted?: boolean;
    };
  }
> = gql`
  mutation UpdatePersonProfileDocument($input: BackofficeUpdatePersonProfileDocumentInput!) {
    updatePersonProfileDocument(input: $input) {
      success
      message
      personProfileDocument {
        id
        name
        description
        category
        filename
        url
        privacyRestricted
        createdAt
      }
    }
  }
`;

export const DELETE_PERSON_PROFILE_DOCUMENT_MUTATION: TypedDocumentNode<
  { deletePersonProfileDocument: PersonProfileDocumentMutationResponse },
  { input: { id: string } }
> = gql`
  mutation DeletePersonProfileDocument($input: BackofficeDeletePersonProfileDocumentInput!) {
    deletePersonProfileDocument(input: $input) {
      success
      message
    }
  }
`;
